import type { ArticuloXListaPrecio } from '../services/articuloXListaPrecioService';

const round2 = (value: number): number => Math.round(value * 100) / 100;

const normalizarNumero = (value: unknown): number | null => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  return parsed;
};

const normalizarCodigoMoneda = (value: unknown): number | null => {
  const parsed = normalizarNumero(value);
  if (parsed === null || parsed === 0) {
    return null;
  }
  return parsed;
};

export const obtenerCodigoListaCliente = (cliente: any): string => {
  const raw =
    cliente?.nroLista ??
    cliente?.nrolista ??
    cliente?.listaPrecio?.codigoLista ??
    cliente?.listaprecio?.codigoLista ??
    '';
  return String(raw || '').trim();
};

export const obtenerPrecioBaseProducto = (producto: any): number => {
  const precioStock = normalizarNumero(producto?.precio);
  if (precioStock !== null && precioStock > 0) {
    return round2(precioStock);
  }

  const fallback = normalizarNumero(
    producto?.precioVenta ??
      producto?.costo ??
      producto?.precioLista ??
      producto?.precioUnitario ??
      0,
  );

  if (fallback === null || fallback <= 0) {
    return 0;
  }
  return round2(fallback);
};

export type ResultadoPrecioLista =
  | {
      tipo: 'precioVta';
      precioLista: number;
      codigoMoneda: number | null;
    }
  | {
      tipo: 'porcentaje';
      precioLista: number;
      porcentaje: number;
      precioBase: number;
      codigoMoneda: number | null;
    }
  | {
      tipo: 'sinPrecio';
      codigoMoneda: number | null;
    };

export const resolverPrecioDesdeLista = (
  producto: any,
  registroLista: ArticuloXListaPrecio | null,
): ResultadoPrecioLista => {
  if (!registroLista) {
    return { tipo: 'sinPrecio', codigoMoneda: null };
  }

  const codigoMoneda = normalizarCodigoMoneda(registroLista.codigoMoneda);
  const precioVta = normalizarNumero(registroLista.precioVta);
  if (precioVta !== null && precioVta !== 0) {
    return {
      tipo: 'precioVta',
      precioLista: round2(precioVta),
      codigoMoneda,
    };
  }

  const porcentaje = normalizarNumero(registroLista.porcentaje);
  if (porcentaje === null) {
    return { tipo: 'sinPrecio', codigoMoneda };
  }

  const precioBase = obtenerPrecioBaseProducto(producto);
  if (precioBase <= 0) {
    return { tipo: 'sinPrecio', codigoMoneda };
  }

  const precioCalculado = round2(precioBase * (1 + porcentaje / 100));
  if (precioCalculado <= 0) {
    return { tipo: 'sinPrecio', codigoMoneda };
  }

  return {
    tipo: 'porcentaje',
    porcentaje,
    precioBase,
    precioLista: precioCalculado,
    codigoMoneda,
  };
};
